/* Built In Imports */
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

/* External Imports */
import { Box, Button } from '@chakra-ui/react';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Components */
import { mixPanel } from '@utils/Mixpanel';

/* Services */
import { isVisInViewport } from '@components/Utility/Shared/SharedService';

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const HostGuidStickyButton = ({
  sectionContent,
  region,
  lang,
  pageData,
  prgData,
}) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [isVisible, setIsVisible] = useState(false);
  const router = useRouter();
  const Mixpanel = mixPanel(router.asPath);

  const handleHostGuide = () => {
    if (!isMobile) {
      const targetElement = document.getElementById(
        'download-host-guide-section'
      );
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Add hash to URL and open drawer
      window.location.hash = 'host-guide-popup';
    }
    Mixpanel.track('HWP_Download_hostguide');
  };

  useEffect(() => {
    const listenToScroll = () => {
      const msrTopBannerDiv = document.getElementById(
        'msr-host-watch-party-banner'
      );
      const prgFeesDiv = document.getElementById('download-host-guide-section');
      // const msrFooterDiv = document.getElementById('msr-footer');

      const winScroll =
        document.body.scrollTop || document.documentElement.scrollTop;

      if (winScroll) {
        const inTopBannerViewPort =
          msrTopBannerDiv && isVisInViewport(msrTopBannerDiv);
        const inFeeViewPort = prgFeesDiv && isVisInViewport(prgFeesDiv);
        // const inFooterViewPort = msrFooterDiv && isVisInViewport(msrFooterDiv);

        if (inTopBannerViewPort || inFeeViewPort) {
          setIsVisible(false);
        } else if (!sectionContent?.[0]?.buttonText) {
          setIsVisible(false);
        } else {
          setIsVisible(true);
        }
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', listenToScroll);
    return () => window.removeEventListener('scroll', listenToScroll);
  }, [sectionContent]);

  return (
    isVisible && (
      <Box
        position="fixed"
        top={{ base: 'unset', md: '50%' }}
        bottom={{ base: '2%', md: 'unset' }}
        zIndex="100"
        right={{ base: 'unset', md: '0' }}
        left={{ base: '0', md: 'unset' }}
        width={{ base: '100%', md: '184px' }}
        onClick={handleHostGuide}
      >
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'space-around'}
          flexDirection={{ base: 'row', md: 'column' }} // Set flexDirection to column for md
        >
          <Box>
            <Button
              className="orange-button"
              display="block"
              fontWeight="500"
              fontFamily="FedraSansStd-medium"
              fontSize="16px"
              bgColor="yellow.100"
              h={{ base: 'auto', md: '73px' }}
              minH={{ base: '50px', md: '73px' }}
              border="none"
              textAlign={{ base: 'center', md: 'left' }}
              py="15px"
              px={{ base: '22px', md: '15px' }}
              borderLeftRadius="5px"
              borderRightRadius={{ base: '5px', md: '0px' }}
              color="black"
              textDecoration="none"
              width={{ base: 'auto', md: '100%' }}
              _hover={{
                bg: 'fulvous',
              }}
              maxW={{ base: '100%', md: '184px' }}
              whiteSpace="break-spaces"
              textDecor="none"
              _focus={{ outline: '0' }}
            >
              {sectionContent?.[0]?.buttonText}
            </Button>
          </Box>
        </Box>
      </Box>
    )
  );
};

export default HostGuidStickyButton;
